function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import generateUtilityClass from '@mui/utils/generateUtilityClass';
import composeClasses from '@mui/utils/composeClasses';
import capitalize from '@mui/utils/capitalize';
import useThemePropsSystem from "../useThemeProps/index.js";
import systemStyled from "../styled/index.js";
import createTheme from "../createTheme/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
var defaultTheme = createTheme();
var defaultCreateStyledComponent = systemStyled('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles["maxWidth".concat(capitalize(String(ownerState.maxWidth)))],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
var useThemePropsDefault = function(inProps) {
    return useThemePropsSystem({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: defaultTheme
    });
};
var useUtilityClasses = function(ownerState, componentName) {
    var getContainerUtilityClass = function(slot) {
        return generateUtilityClass(componentName, slot);
    };
    var classes = ownerState.classes, fixed = ownerState.fixed, disableGutters = ownerState.disableGutters, maxWidth = ownerState.maxWidth;
    var slots = {
        root: [
            'root',
            maxWidth && "maxWidth".concat(capitalize(String(maxWidth))),
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return composeClasses(slots, getContainerUtilityClass, classes);
};
export default function createContainer() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_createStyledComponent = options.// This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent, createStyledComponent = _options_createStyledComponent === void 0 ? defaultCreateStyledComponent : _options_createStyledComponent, _options_useThemeProps = options.useThemeProps, useThemeProps = _options_useThemeProps === void 0 ? useThemePropsDefault : _options_useThemeProps, _options_componentName = options.componentName, componentName = _options_componentName === void 0 ? 'MuiContainer' : _options_componentName;
    var ContainerRoot = createStyledComponent(function(param) {
        var theme = param.theme, ownerState = param.ownerState;
        return _object_spread({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto'
        }, !ownerState.disableGutters && // @ts-ignore module augmentation fails if custom breakpoints are used
        _define_property({
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        }, theme.breakpoints.up('sm'), {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }));
    }, function(param) {
        var theme = param.theme, ownerState = param.ownerState;
        return ownerState.fixed && Object.keys(theme.breakpoints.values).reduce(function(acc, breakpointValueKey) {
            var breakpoint = breakpointValueKey;
            var value = theme.breakpoints.values[breakpoint];
            if (value !== 0) {
                // @ts-ignore
                acc[theme.breakpoints.up(breakpoint)] = {
                    maxWidth: "".concat(value).concat(theme.breakpoints.unit)
                };
            }
            return acc;
        }, {});
    }, function(param) {
        var theme = param.theme, ownerState = param.ownerState;
        return _object_spread({}, ownerState.maxWidth === 'xs' && // @ts-ignore module augmentation fails if custom breakpoints are used
        _define_property({}, theme.breakpoints.up('xs'), {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            maxWidth: Math.max(theme.breakpoints.values.xs, 444)
        }), ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== 'xs' && // @ts-ignore module augmentation fails if custom breakpoints are used
        _define_property({}, theme.breakpoints.up(ownerState.maxWidth), {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            maxWidth: "".concat(theme.breakpoints.values[ownerState.maxWidth]).concat(theme.breakpoints.unit)
        }));
    });
    var Container = /*#__PURE__*/ React.forwardRef(function Container(inProps, ref) {
        var props = useThemeProps(inProps);
        var className = props.className, _props_component = props.component, component = _props_component === void 0 ? 'div' : _props_component, _props_disableGutters = props.disableGutters, disableGutters = _props_disableGutters === void 0 ? false : _props_disableGutters, _props_fixed = props.fixed, fixed = _props_fixed === void 0 ? false : _props_fixed, _props_maxWidth = props.maxWidth, maxWidth = _props_maxWidth === void 0 ? 'lg' : _props_maxWidth, classesProp = props.classes, other = _object_without_properties(props, [
            "className",
            "component",
            "disableGutters",
            "fixed",
            "maxWidth",
            "classes"
        ]);
        var ownerState = _object_spread_props(_object_spread({}, props), {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        var classes = useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        _jsx(ContainerRoot, _object_spread({
            as: component,
            ownerState: ownerState,
            className: clsx(classes.root, className),
            ref: ref
        }, other)));
    });
    process.env.NODE_ENV !== "production" ? Container.propTypes = {
        children: PropTypes.node,
        classes: PropTypes.object,
        className: PropTypes.string,
        component: PropTypes.elementType,
        disableGutters: PropTypes.bool,
        fixed: PropTypes.bool,
        maxWidth: PropTypes /* @typescript-to-proptypes-ignore */ .oneOfType([
            PropTypes.oneOf([
                'xs',
                'sm',
                'md',
                'lg',
                'xl',
                false
            ]),
            PropTypes.string
        ]),
        sx: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.oneOfType([
                PropTypes.func,
                PropTypes.object,
                PropTypes.bool
            ])),
            PropTypes.func,
            PropTypes.object
        ])
    } : void 0;
    return Container;
}
